module.exports = __webpack_public_path__ + "static/media/atm.41c88687.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/articles/atm.jpg
// module id = 157
// module chunks = 0